const AccordionToggle = () => {
    const accordionToggles = document.querySelectorAll('.accordion-toggle');
    accordionToggles.forEach(toggleBtn => {
        toggleBtn.addEventListener('click', function () {
            const targetId = this.getAttribute('data-target');
            const bodyEl = document.getElementById(targetId);
            bodyEl.classList.toggle('hidden');
            const plusMinusEl = this.querySelector('.plus-minus');
            if (plusMinusEl) {
                const plusIcon = plusMinusEl.querySelector('.plus');
                const minusIcon = plusMinusEl.querySelector('.minus');
                plusIcon.classList.toggle('hidden');
                minusIcon.classList.toggle('hidden');
            }
        });
    });

};

export default AccordionToggle;